<template>
<div>
    <main>
        <router-view></router-view>
    </main>
</div>
</template>


<script>

export default {
  name: "login-template",
  components: {

  },
  mounted: function() {
   
  },
  methods: {
  
  }
};
</script>

